import React from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'ar', name: 'العربية' },
  { code: 'id', name: 'Bahasa' },
  { code: 'fr', name: 'Français' },
  { code: 'pl', name: 'Polski' },
  { code: 'el', name: 'Ελληνικά' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    // Store preference
    localStorage.setItem('i18nextLng', langCode);
    localStorage.setItem('manualLanguageSelected', 'true'); // Persist across sessions
    sessionStorage.setItem('manualLanguageSelected', 'true');
  };

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <select
        className="form-select"
        value={currentLanguage.name}
        onChange={(e) => {
          const selectedLang = languages.find(lang => lang.name === e.target.value);
          if (selectedLang) {
            handleLanguageChange(selectedLang.code);
          }
        }}
        style={{
          background: 'black',
          color: 'white',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          padding: '0.5rem 2.5rem 0.5rem 0.5rem',
          borderRadius: '5px',
          cursor: 'pointer',
          appearance: 'none',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
        }}
      >
        {languages.map((lang) => (
          <option
            key={lang.code}
            value={lang.name}
            style={{ color: 'black', background: 'white' }}
          >
            {lang.name}
          </option>
        ))}
      </select>
      <svg
        style={{
          position: 'absolute',
          right: '0.75rem',
          top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          width: '12px',
          height: '12px',
        }}
        fill="white"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
}

